import { WithLoadingPropTypes } from 'hocs/withLoading';
import PropTypes from 'prop-types';

export const pagesPropTypes = {
  // * data props
  applicationData: PropTypes.object.isRequired,
  entitySideData: PropTypes.object.isRequired,
  initialEntitySideData: PropTypes.object,
  setEntitySideData: PropTypes.func.isRequired,
  setInitialEntitySideData: PropTypes.func,

  // * config props
  setEntityConfig: PropTypes.func.isRequired,
  setConfig: PropTypes.func,

  // * form related props
  form: PropTypes.object,
  validationErrors: PropTypes.object.isRequired,
  validateField: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  staticValidateField: PropTypes.func.isRequired,
  setValidationErrors: PropTypes.func.isRequired,
  setInForm: PropTypes.func.isRequired,
  setMultipleInForm: PropTypes.func.isRequired,
  setForm: PropTypes.func.isRequired,
  setInitialFormValues: PropTypes.func,
  setIsFormChanged: PropTypes.func,
  initialFormValues: PropTypes.object,

  // * pending changes related props
  pendingChanges: PropTypes.object.isRequired,
  disabledPendingChangesHighlight: PropTypes.bool.isRequired,

  // * other props
  setIsNestedEntityEditActive: PropTypes.func.isRequired,
  setIsSavingAllowed: PropTypes.func,
  className: PropTypes.string,
  isWithInfoTitle: PropTypes.bool,
  isDeletedRecord: PropTypes.bool,
  ...WithLoadingPropTypes,
};

export const defaultForm = {};
export const defaultInitialEntitySideData = {};
export const defaultInitialFormValues = {};
